module.exports = __webpack_public_path__ + "img/3_99.9219b04c.png";